import get from 'lodash/get';
import cmsCustomer from './cmsCustomer';

export function select(path: string) {
  return get(cmsCustomer, path);
}
